//
// locale_sv.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/sv.json';
import localeData from "react-intl/locale-data/sv.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_sv.js